<template>
    <b-modal v-model="localIsOpen" title="User Details" hide-footer>
        <b-form-input
            v-model="searchQuery"
            placeholder="Search..."
            class="mb-3"
        ></b-form-input>

        <div class="modal-body-scrollable">
            <div v-if="loading" class="text-center">
                <b-spinner></b-spinner>
            </div>
            <div v-else-if="filteredLogs.length">
                <b-table
                    :items="paginatedLogs"
                    :fields="getHeaders(userLogs)"
                    striped
                    hover
                ></b-table>
                <b-pagination
                    v-model="currentPage"
                    :total-rows="filteredLogs.length"
                    :per-page="perPage"
                    align="center"
                    class="mt-3"
                ></b-pagination>
            </div>
            <p v-else class="text-center text-muted">No Data Available</p>
        </div>

        <b-button variant="secondary" block @click="closeModal">Close</b-button>
    </b-modal>
</template>

<script>
import { GetUserLogs } from "../../Helper/UserApiHelper";

export default {
    props: {
        user: Object,
        isOpen: Boolean,
        tenantId: String,
    },
    data() {
        return {
            userLogs: [],
            loading: false,
            searchQuery: "",
            currentPage: 1,
            perPage: 10, // Number of records per page
            localIsOpen: this.isOpen, // Local state for modal visibility
        };
    },
    computed: {
        filteredLogs() {
            if (!this.searchQuery) return this.userLogs;
            return this.userLogs.filter(log =>
                Object.values(log).some(
                    value =>
                        value &&
                        value.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
                )
            );
        },
        paginatedLogs() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.filteredLogs.slice(start, start + this.perPage);
        },
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.fetchUserLogs();
            }
            this.localIsOpen = newVal; // Sync prop with local state
        },
        localIsOpen(newVal) {
            if (newVal !== this.isOpen) {
                this.$emit("update:isOpen", newVal); // Emit event to sync parent state
            }
        },
    },
    methods: {
        async fetchUserLogs() {
            if (!this.user?.id || !this.tenantId) return;

            this.loading = true;
            try {
                const logsData = {
                    UserID: this.user.id,
                    TenantID: this.tenantId,
                };
                const userLogs = await GetUserLogs(logsData);
                this.userLogs = Array.isArray(userLogs) ? userLogs : [];
            } catch (error) {
                console.error("Error fetching user logs:", error);
                this.userLogs = [];
            } finally {
                this.loading = false;
            }
        },
        getHeaders(items) {
            if (!items.length) return [];
            return Object.keys(items[0]).map((key) => ({
                key,
                label: this.formatHeader(key),
            }));
        },
        formatHeader(key) {
            return key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
        },
        closeModal() {
            this.$emit("update:isOpen", false); // Emit close event to parent
        },
    },
};
</script>

<style scoped>
.modal-body-scrollable {
    max-height: 400px; /* Adjust height as needed */
    overflow-y: auto;
}
</style>
